export const COOKIE_PERFORMANCE = "AcceptedPerformanceCookies";
export const COOKIE_STATISTICS = "AcceptedStatisticsCookies";
export const COOKIE_MARKETING = "AcceptedMarketingCookies";
